$(document).ready(function() {

	var dirRtlFlag = false;
	if ($("html").attr('dir') == 'rtl') {
		dirRtlFlag = true;
	}

	$('.hp-articles__items').slick({
		vertical: true,
		dots: false,
	  
		// infinite: true,
		speed: 2000,
		slidesToShow: 3, 
		slidesToScroll: 1,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 2000,
		// rtl: dirRtlFlag,
		nextArrow: '<a href="#" class=" arrow slidesjs-next slidesjs-navigation"><i class="fa fa-chevron-right"></i></a>',
    prevArrow: '<a href="#" class="arrow slidesjs-previous slidesjs-navigation"><i class="fa fa-chevron-left"></i></a>',
		responsive: [{
				breakpoint: 998,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 620,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
})